// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3u11w","imageUploader":"EGiftCard_imageUploader__1Olzb"};